import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Paper,
  Container,
  TextField,
  Button,
  CardMedia,
  InputAdornment,
  Divider,
  Rating,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SendIcon from "@mui/icons-material/Send";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ReplyIcon from "@mui/icons-material/Reply";
import db from "./Products.database.js"; // Import your database or API call here

const Reviews = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const { products } = db();
    const foundProduct = products.find(
      (product) => product.id === parseInt(id)
    );
    if (foundProduct) {
      setProduct({
        name: foundProduct.title,
        img: foundProduct.image,
        rating: foundProduct.rating ? Number(foundProduct.rating) : 0,
        description: foundProduct.description || "",
      });

      setReviews([
        {
          id: 1,
          name: "Ronti Jordan",
          date: "12 Days ago",
          rating: 4,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 24,
        },
        {
          id: 2,
          name: "Jenillya Cartoes",
          date: "25 Dec, 2020",
          rating: 5,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 31,
        },
        {
          id: 3,
          name: "Alex Thompson",
          date: "5 Jan, 2021",
          rating: 4,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 18,
        },
        {
          id: 4,
          name: "Sophia Lee",
          date: "19 Feb, 2021",
          rating: 5,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 42,
        },
        {
          id: 5,
          name: "Michael Chen",
          date: "3 Mar, 2021",
          rating: 4,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 29,
        },
        {
          id: 6,
          name: "Emma Rodriguez",
          date: "17 Apr, 2021",
          rating: 5,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 37,
        },
        {
          id: 7,
          name: "David Kim",
          date: "2 May, 2021",
          rating: 4,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 22,
        },
        {
          id: 8,
          name: "Olivia Patel",
          date: "14 Jun, 2021",
          rating: 5,
          comment:
            "Aliqua officia duis occaecat consectetur fugiat nostrud anim dolor commodo officia proident. Voluptate nisi reprehenderit.",
          likes: 33,
        },
      ]);
    } else {
      setProduct(null);
    }
  }, [id]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: "#F6F6F6",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "16px",
          backgroundColor: "#F6F6F6",
          color: "black",
        }}
        onClick={() => navigate(`/products/details/${id}`)}
      >
        <IconButton sx={{ color: "black" }}>
          <ArrowBackIosNewIcon />
        </IconButton>
        <Typography variant="h6" sx={{ marginLeft: 1 }}>
          Details
        </Typography>
      </Box>
      <CardMedia
        component="img"
        src={product?.img}
        alt={product?.name}
        sx={{
          width: 150,
          height: 150,
          objectFit: "contain",
          display: "block",
          margin: "0 auto",
        }}
      />

      {/* Chat Box */}
      <Box sx={{ backgroundColor: "white" }}>
        <Box
          sx={{
            flexGrow: 1,
            position: "relative",
            padding: "16px",
            backgroundColor: "white",
            borderRadius: "40px 40px 0 0",
          }}
        >
          {/* Product Image & Title */}
          {product ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "16px",
                backgroundColor: "white",
              }}
            >
              <Typography variant="h6" align="left" sx={{ marginTop: 2 }}>
                {product.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {product.description}
              </Typography>
            </Box>
          ) : (
            <Typography sx={{ padding: "16px" }}>Product not found.</Typography>
          )}

          <Divider variant="middle" />
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              height: "20px",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0.8), rgba(255,255,255,0))",
              pointerEvents: "none",
              zIndex: 1,
            }}
          />
          {/* Chat Messages */}
        </Box>

        <Box sx={{ flexGrow: 1, padding: 2, overflowY: "auto" }}>
          {reviews.map((review) => (
            <Paper key={review.id} elevation={0} sx={{ padding: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar sx={{ width: "5vh", height: "5vh", marginRight: 2 }} />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {review.name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {review.date}
                  </Typography>
                </Box>
              </Box>
              <Rating value={review.rating} readOnly sx={{ marginTop: 1 }} />
              <Typography variant="body2" sx={{ marginTop: 1 }}>
                {review.comment}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", marginTop: 1 }}>
                <IconButton>
                  <FavoriteIcon sx={{ color: "#EF4F26" }} />
                </IconButton>
                <Typography variant="caption" sx={{ marginRight: 2 }}>
                  {review.likes} Like
                </Typography>
                <IconButton>
                  <ReplyIcon />
                </IconButton>
                <Typography variant="caption">Reply</Typography>
              </Box>
              <Divider variant="middle" sx={{ mt: 1 }} />
            </Paper>
          ))}
        </Box>

        {/* Input Field */}
        <Box
          sx={{
            position: "fixed",
            bottom: 30,
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
            maxWidth: 600,
            backgroundColor: "#fff",
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
            borderRadius: "24px",
            zIndex: 1000,
          }}
        ></Box>
        <Box
          sx={{
            position: "fixed",
            bottom: 30,
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
            maxWidth: 600,
            backgroundColor: "#fff",
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
            borderRadius: "24px",
            zIndex: 1000,
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Type your message..."
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            //   onKeyDown={(e) => {
            //     if (e.key === "Enter") handleSendMessage();
            //}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // onClick={handleSendMessage}
                    color="primary"
                  >
                    <SendIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "24px", 
              },
            }}
          />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            textAlign: "center",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "8px",
            fontSize: "12px",
            color: "black",
            zIndex: 1,
            position: "fixed",
            bottom: 0,
          }}
        >
          Powered by <span style={{ color: "#EF4F26" }}>Flexday</span>
        </Box>
      </Box>
    </Box>
  );
};

export default Reviews;
